export default __webpack_public_path__ + "static/media/new-calender-o.3f9835e3.svg";